import { useState } from "react"

export const VariableProfile = () => {
    const [state, setState] = useState({
        name: '',
        email: '',
        old_password: '',
        new_password: '',
        new_password_confirmation: '',
        Load: false
    })
    const setStateCustom = (variableName, value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            [variableName]: value,
        }));
    };
    const setLoad = (value) => {
        console.log(value)
        setState((prevState) => ({
            ...prevState,
            Load: value,
        }));
    };
    return {
        ...state,
        state,
        setState,
        setStateCustom,
        setLoad,
    }
}
